<script setup lang="ts">



const props = defineProps<{
  title?: string,
}>()

</script>

<template>
  <div class="py-10 w-full">


    <UDashboardNavbar :ui="{
      right: 'gap-3 shrink-0',
      center: 'flex items-center justify-center min-w-0 flex-1'
    }">
      <template #leading>
      </template>

      <template #default>
        <!--
      The 'truncate' class here only works if the parent
      (the center slot) has a defined width or min-w-0
    -->
        <h1 v-if="title" class="min-w-0 truncate text-center whitespace-nowrap text-3xl md:text-5xl font-bold">
          <UIcon name="i-app-icon-logo" class="text-3xl md:text-5xl font-bold" />&nbsp;{{ props.title }}
        </h1>
        <div v-else class="flex items-center justify-center min-w-0 truncate whitespace-nowrap">
          <UIcon name="i-app-icon-logo" class="text-3xl md:text-5xl font-bold" />
          <h1 class="text-3xl md:text-5xl font-bold">
            &nbsp;Trolley
          </h1>

          <h1 class="font-mistrully text-3xl md:text-5xl font-bold">
            Mate&nbsp;
          </h1>

          <h1 class="text-3xl md:text-5xl font-bold">
            Insights
          </h1>
        </div>
      </template>

      <template #right>
        <div class="flex items-center py-4">
          <SharedLocalePickerDropdownMenu />
        </div>
      </template>
    </UDashboardNavbar>


  </div>
</template>
